import React from "react";
import './Header.css';

function Header() {
    return (
        <header className="header-container">
            <h1>吃什么</h1>
        </header>
    );
}

export default Header;